import createRoutes from './createRoutes'
import { createRouter } from './createrRouter'

const routes = createRoutes()
const router = createRouter(routes)

export default router
